<template>

<div>

    <div v-if="matchedUsers" class="flex-fill overflow-auto p-0">
        <div class="">
            <div class="navbar navbar-light bg-light navbar-expand-lg py-lg-2 border-bottom">
                <div class="btn-group mr-3">
                    <button class="btn btn-otu border" type="button" @click="send" :disabled="sending"><font-awesome-icon class="mr-1" :icon="['far', 'paper-plane']" /> {{ $t('messages.send_button') }}</button>
                    <button class="btn btn-outline-otu border" type="button" @click="messageAutoSave"><font-awesome-icon class="mr-1" :icon="['fas', 'share']" /> {{ $t('messages.save_draft_button') }}</button>
                    <button class="btn btn-outline-otu border" type="button" @click="cancelDraft"><font-awesome-icon class="mr-1" :icon="['far', 'trash-alt']" /> {{ $t('messages.cancel_draft_button') }}</button>
                </div>
            </div>
        </div>

        <div class="card-body border-bottom">
            <div class="row">
                <div class="col font-weight-bold">{{ $t('messages.to')}} </div>
                <div class="col col-10">
                    <b-form-select v-model="mail.to" :options="recipients" class="mb-3" v-if="recipients && recipients.length > 1" />
                    <div v-else-if="recipients" class="mb-3">{{ recipients[0].text }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">{{ $t('messages.subject')}} </div>
                <div class="col col-10"><b-form-input v-model="mail.subject" type="text" maxlength="200"></b-form-input></div>
            </div>
        </div>

        <froala :tag="'textarea'" :config="config" v-model="mail.body"></froala>

    </div>
    <div v-else>
        <div class="alert alert-warning" role="alert">
            {{ $t('messages.no_matched_users') }}
        </div>
    </div>


</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import User from '@/models/user'
import Message from '@/models/message'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers'
import moment from 'moment'

export default {
	name: 'MessagesCompose',
    data () {
        return {
            mail: { to: null, body: '' },
            config: {
                key: process.env.VUE_APP_FROALA_KEY,
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'emoticons', 'clearFormatting', 'html', '|', 'undo', 'redo'],
                saveInterval: 0,
                inlineMode: false,
                heightMin: 400,
                htmlAllowedTags: ['p','b','strong','h1','h2','h3','h4','h5','h6','li','ul','ol','small','i','em','u'],
                emoticonsUseImage: false,
                pastePlain: true,
                toolbarSticky: false
            },
            changed: false,
            sending: false
        }
    },
    beforeDestroy () {
    	EventBus.$off('heartbeat-event', this.messageAutoSave); // Deregister Event Listeners
    },
    mounted () {
        EventBus.$on('heartbeat-event', this.messageAutoSave);
        if (this.$route.name == 'messages.draft') this.getDraft(this.$route.params.id);
        else if (this.$route.name == 'messages.reply') this.getReply(this.$route.params.folder_id, this.$route.params.id);
        else if (this.$route.name == 'messages.compose') {
            if (this.$route.query && this.$route.query.to) {
                // If TO ID is passed, see if they have access before setting the TO value
    			let to = this.$route.query.to;
                if (_.find(this.recipients, { 'value': to })) this.mail.to = to;
    		}
        }
    },
    created () {
        //this.fetchMatchings();
        this.mail = new Message ({sender_id: this.currentUserId });
    },
    computed: {
        ...mapGetters(['typeFolders']),
        matchedUsers () {
            return this.$store.state.users.users;
        },
        recipients () {
            let ret = [];
            if (this.matchedUsers) {
                let keys = Object.keys(this.matchedUsers);
                if (keys.length > 1) {
                    let mu = this.matchedUsers;
                    keys.forEach(function(userId) {
                        let fname = mu[userId].first_name;
                        let lname = mu[userId].last_name;
                        ret.push({value: userId, text: fname+' '+lname})
                    });
                } else if (keys.length == 1) {
                    let userId = keys[0];
                    ret.push({value: userId, text: this.matchedUsers[userId].first_name+' '+this.matchedUsers[userId].last_name})
                    this.mail.to = userId;
                }

                return ret;
            }
        }
    },
    watch: {
        'mail': { // Only Save when changed
            handler: function() { this.changed = true; },
            deep: true
        }
    },
    methods: {
        ...mapActions(['fetchMessage', 'fetchMatchings', 'createDraft', 'saveDraft', 'sendMessage']),
        ...mapNotificationEventActions,
        send () {
            this.sending = true;
            this.sendMessage(this.mail).then((v) => {
                this.emitSuccess({msg:'Message sent'});
                this.$router.push({ name: 'messages.listing', params: { id: this.typeFolders(40)[0].id } });
            }).catch( (err) => {
                errHandler(err);
                this.sending = false;
            });
        },
        messageAutoSave () {
          if (this.mail.subject && this.mail.body && this.changed) {
              if (this.mail.id > 0) { // Save Draft
                  this.saveDraft(this.mail).then((v) => {
                      this.emitSuccess({msg: this.$t('messages.draft_saved') });
                  }).catch( (err) => errHandler(err));
              } else {
                    this.createDraft(this.mail).then((msg) => {
                        this.emitSuccess({msg: this.$t('messages.draft_saved') });
                        //this.mail = this.$store.state.messages.message;
                        //this.$router.push({ name: 'messages.draft', params: { id: this.mail.id } });
                        this.mail.id = msg.id;
						this.mail.folder_id = msg.folder_id;
                    }).catch( (err) => errHandler(err));
              }
           }
           this.changed = false;
        },
        cancelDraft () {
            this.$router.go(-1);
        },
        getDraft (msgId) {
            if (this.typeFolders) {
                this.fetchMessage({folderId: this.typeFolders(20)[0].id, messageId: msgId})
                    .then((e) => { this.mail = this.$store.state.messages.message; }).catch( (err) => errHandler(err));
            }
        },
        getReply (fldId, msgId) {
            this.fetchMessage({folderId: fldId, messageId: msgId})
                .then((e) => {
                    this.mail = this.$store.state.messages.message;

                    let sender = this.mail.sender;
                    this.mail.to = [];
                    this.mail.to[sender.id] = new User ({ id: sender.id, firstName: sender.first_name, lastName: sender.last_name });

                    let sentTime = moment(String(this.mail.sent_at)).format('MMM D, YYYY, hh:mm a')

                    this.mail.id = -1;
                    this.mail.folder_name = null;
                    this.mail.folder_id = null;
                    this.mail.read_at = null;
                    this.mail.urgent = false;
                    this.mail.sender = null;
                    this.mail.sender_id = null;
                    this.mail.sent_at = null;
                    this.mail.subject = "Re: " + this.mail.subject;
                    this.mail.body = "<p></p><hr /><em>On "+sentTime+", "+sender.first_name+" "+sender.last_name+" wrote:</em><br />" + this.mail.body;
                }).catch((err) => errHandler(err));
        },
    }
}
</script>
